<template>
	<div class="customFixed-vue alertPOP darkFadeBG loginInfo" v-show="!isAutoLogin">
	    <div class="custom-modal showTabs secondary-color openHeader">
	    	<app-loader v-if="pageLoader"/>
	    	<div class="mainContent" v-if="gAuthenticatorEnabled">
	    		<div class="topSettingHead position-relative border-bottom p-3">
					<div class="text-center mb-2">
						<img src="../../../../static/website/images/act-trader-logo.svg" alt="" height="50px" v-if="product == 'act'"/>
						<img :src="LIGHT_LOGO_URL" alt="" height="50px" v-else-if="$parent.$parent.theme"/>
						<img :src="DARK_LOGO_URL" alt="" height="50px" v-else/>
					</div>
	    			<p class="f-14 mb-0">{{$t('2fa_verification') }} </p>
					<span class="closePOP" @click.prevent="$emit('close')" v-if="Object.keys(login_user).length"><feather size="13px" type="x"></feather></span>
					<!-- <span class="closePOP" @click.prevent="$parent.usrLogin = false"><feather size="13px" type="x"></feather></span> -->
	    		</div>
	    		<div class="mainTab-one">
			    	<div class="updateWrap" >
			    		<div class="form-fields" :class="[{'validation-error':submitted2 && errors.has('otp')}]">
								<input type="text" placeholder="Google verification code" name="otp" v-model="otp" v-validate="'required|numeric|min:6'" maxlength="6" ref="otpInput" @keyup.enter="login2Fa()">
							<span class="text-danger-error" v-if="submitted2 && errors.has('otp')">
								<span class="text-danger" >{{ errors.first('otp') }}</span>
							</span>
						</div>
						<div class="fullWidh d-flex align-items-center justify-content-between my-4">
							<button class="btn appButton linkBG justify-content-center" @click.prevent="login2Fa()">{{$t('verify') }}</button>
							<div class="d-flex align-items-center mb-0">
								<p><a href="#" @click.prevent="$parent.page_type = 'register'"> {{$t('create_demo_account') }} </a></p>
							</div>
						</div>
						<div class="d-flex align-items-center mb-4">
							<p><a href="#" @click.prevent="BackLogin()">{{$t('login_another_account') }} </a></p>
						</div>
					</div>
			    </div>
	    	</div>
	    	<div class="mainContent" v-else>
	    		<div class="topSettingHead position-relative border-bottom p-3">
					<div class="text-center mb-2">
						<img src="../../../../static/website/images/act-trader-logo.svg" alt="" height="50px" v-if="product == 'act'"/>
						<img :src="LIGHT_LOGO_URL" alt="" height="70px" v-else-if="product == 'Capital-Street'"/>
						<img :src="LIGHT_LOGO_URL" alt="" height="50px" v-else-if="$parent.$parent.theme"/>
						<img :src="DARK_LOGO_URL" alt="" height="50px" v-else/>
					</div>
	    			<p class="f-14 mb-0">{{$t('login') }}</p>
					<span class="closePOP" @click.prevent="$emit('close')" v-if="Object.keys(login_user).length"><feather size="13px" type="x"></feather></span>
					<!-- <span class="closePOP" @click.prevent="$parent.usrLogin = false"><feather size="13px" type="x"></feather></span> -->
	    		</div>
	    		<div class="mainTab-one">
		    	<form class="updateWrap" @submit.prevent="login()">
		    		<div class="form-fields" :class="[{'validation-error':submitted && errors.has('Username')}]">
						<input type="text" placeholder="Enter Trading Account Number" name="Username" v-model="Username" v-validate="'required|max:30'" ref="UsernameInput" maxlength="30">
						<span class="text-danger-error" v-if="submitted && errors.has('Username')">
							<span class="text-danger">{{ errors.first('Username') }}</span>
						</span>
					</div>
					
		    		<!-- <div class="form-fields d-flex align-items-center mb-3">
		    			<input type="email" placeholder="Enter Email" name="">
		    		</div> -->
		    		<div class="form-fields" :class="[{'validation-error':submitted && errors.has('password')}]">
		    			<div class="position-relative iconInput">
			    			<input :type="(showPass)?'text':'password'" placeholder="Enter Password" name="password" v-model="password" v-validate="'required|max:30'" ref="passwordInput" maxlength="30">
			    			<feather :type="(showPass)?'eye':'eye-off'" @click="showPass = !showPass"></feather>
			    		</div>
		    			<!-- <div class="fogotPass text-right">
		    				<a @click.prevent="$parent.page_type = 'forgot'" href="#">Forgot Password?</a>
		    			</div> -->
		    			<span class="text-danger-error" v-if="submitted && errors.has('password')">
			    			<span class="text-danger" >{{ errors.first('password') }}</span>
			    		</span>
		    		</div>
		    		<!-- <div class="form-fields mb-2 mt-n3 d-flex align-items-center justify-content-end">
						<p><a href="#" @click.prevent="$parent.page_type = 'reset'">Reset Password</a></p>
					</div> -->
		    		<div class="form-fields mb-3" :class="[{'validation-error':submitted && errors.has('Server Type')}]">
						<select class="selectBox" v-model="server" name="Server Type" v-validate="'required'" :ref="'Server TypeInput'">
							<option value="" disabled>{{$t('select_server_type') }} </option>
							<option :value="key" v-for="list,key in providerList">{{list}}</option>
							<!-- <option>ActTrader Demo</option>
							<option>Hirose GBP Demo</option>
							<option>Hirose USD Demo</option>
							<option>Hirose EUR Demo</option>
							<option>Hirose GBP Live</option>
							<option>Hirose USD Live</option>
							<option>ActFx</option>
							<option>Axe Capital</option>
							<option>Aviva Arb</option>
							<option>Trading Platform - Demo</option>
							<option>Trading Platform - Live</option> -->
						</select>
						<span class="text-danger-error" v-if="submitted && errors.has('Server Type')">
							<span class="text-danger">{{ errors.first('Server Type') }}</span>
						</span>
					</div>
					<div class="form-fields mb-3">
						<label class="customCheckbox d-inline-flex m-0" v-if="Object.keys(login_user).length == 0">
							{{$t('remember_me') }}
							<input type="checkbox" v-model="remember_me" />
							<span class="checkmark"></span>
						</label>
					</div>
					<div class="fullWidh d-flex align-items-center justify-content-between my-4">
						<button class="btn appButton linkBG justify-content-center"> {{$t('login') }}</button>
						<div class="d-flex align-items-center mb-0" v-if="Object.keys(login_user).length == 0">
							<p v-if="product == 'act' && Object.keys(login_user).length == 0">
								<a href="javascript:void(0)" @click.prevent="$parent.page_type = 'register'">{{$t('create_demo_account') }}</a>
							</p>
							<p v-else>
								<a  :href="register_link || 'javascript:void(0)'":target="register_link ? '_blank' : null">
									{{product === 'Capital-Street' ? $t('create_new_account') : $t('create_demo_account') }} 
								</a></p>
						</div>
					</div>
				</form>
			    </div>
	    	</div>
	    </div>
    </div>
</template>

<script>
import { commonAllmixins } from '@/plugins/commonAll'
import * as types from '@/types'
const register_link = process.env.register_link;
const product = process.env.product;
import UserDB from '@/store/userDB';
export default {
    name: 'login-pop',
    mixins: [commonAllmixins, UserDB ],
    data() {
        return {
            pageLoader : false,
            // change-password
            showPass: false,
            Username: '',
            password: '',
            otp: '',
            token: '',
            server: '',
            submitted : false,
            submitted2 : false,
            gAuthenticatorEnabled : false,
            faFlag : false,
            remember_me : false,
			register_link,
			product,
			DARK_LOGO_URL: process.env.LOGO_URL_DARK,
      		LIGHT_LOGO_URL: process.env.LOGO_URL_LIGHT,
			isAutoLogin: false
        }
    },
	props:{
        login_user:{
            default: {}
        }
    },
	emits:['close'],
    methods:{
    	login2Fa(){
    		const _that = this
            _that.submitted2 = true;
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'token' : _that.token,
                        	"code" : _that.otp.toString(),
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that.$store.dispatch(types.RUN_USER_LOGIN_2FA,input_json)
                }/*else{
                    _that.handleValidationErrorAdvanced(_that.errors)
                }*/
            });
    	},
    	clearAll(){
            this.showPass = false
            this.Username = ''
            this.password = ''
            this.submitted = false
            this.$parent.usrLogin = false
        },
    	BackLogin(){
            this.showPass = false
            this.remember_me = false
            this.Username = ''
            this.password = ''
            this.submitted = false
            this.submitted2 = false
            this.otp = ''
            this.token = ''
            this.gAuthenticatorEnabled = false
            this.$parent.usrLogin = false
        },
        login(){
            const _that = this
            _that.submitted = true;
            if (this.remember_me) {
				var email = this.Username;
				var password =  this.password;
				var server =  this.server;
				// set cookies to expire in 14 days
				this.$cookies.set("email",email.trim(),"14d");
				this.$cookies.set("password",password.trim(),"14d");
				this.$cookies.set("server",server,"14d");
				this.$cookies.set("remember",true,"14d");
			}else {
				// reset cookies
				this.$cookies.set("email",null);
				this.$cookies.set("password",null);
				this.$cookies.set("server",null);
				this.$cookies.set("remember",null);
			}
            _that.$validator.validate().then(valid => {
                if (valid) {
                    let input_json={
                        'globalParams' :{
                            'email' : _that.Username.trim(),
                            'password' : _that.password.trim(),
                            'server_type' : _that.server,
                        },
                        'localParams' :{ "parameter" : _that }
                    }
                    _that.$store.dispatch(types.RUN_LOGIN,input_json)
                    // _that._runChangePassword(input_json)
                }/*else{
                    _that.handleValidationErrorAdvanced(_that.errors)
                }*/
            });
        },
		/*async */addUser() {
			this.saveUser(this.Username, this.server, this.password).then(() => {
				// if(window.isMobileCheck)this.$router.replace('/grid-view');
				location.reload();
			}).catch((err) =>{
				alert("Error adding user:", err);
				location.reload();
			});
			// await this.saveUser(this.Username, this.server, this.password);
			// alert("User added!");
		},
    },
    created(){
    	let remember = this.$cookies.get("remember");
		if ( remember == 'true') {
			this.Username = this.$cookies.get("email") || '';
			this.password = this.$cookies.get("password") || '';
			this.server = this.$cookies.get("server") || '';
			this.remember_me = true
		}else{
			this.email = '';
			this.password = '';
			this.remember_me = false
		}
		if(Object.keys(this.login_user).length){
			if(!this.login_user.addAccount){
				this.isAutoLogin = true;
				// console.log('=====>', this.login_user)
				this.Username = this.login_user.user || '';
				this.password = this.login_user.decrypted.password || '';
				this.server = this.login_user.decrypted.accountType || '';
				this.login()
			}else{
				this.Username = '';
				this.password = '';
				this.server = '';
			}
		}
    	this._runGetProviderList({ 'globalParams' : {},'localParams' : { 'parameter' : this } })
    },
    mounted() {
		const _that = this
        $(document).on("click", function(event){
			if(!$(event.target).closest('.openHeader').length){
                _that.openHeader = false
            }
        });
	}
    
}
</script>





// WEBPACK FOOTER //
// src/components/website/user/login.vue